import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_viewvisitor } from "../shared/data.service";

import { wsVPPAdminVisitorEditDataParm } from "../shared/wsVPPAdminVisitorEditDataParm";
import { wsVPPAdminVisitorEditDataInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataFacilityInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataTypeInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataStatusInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataGenderInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataEthnicityInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataRaceInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorVerifyModifyParm } from "../shared/wsVPPAdminVisitorVerifyModifyParm";
import { wsVPPAdminVisitorOffenderLookupDataParm } from "../shared/wsVPPAdminVisitorOffenderLookupDataParm";
import { wsVPPAdminVisitorOffenderLookupDataInfo } from "../shared/wsVPPAdminVisitorOffenderLookupDataInfo";
import { wsVPPAdminVisitorOffenderLookupItemInfo } from "../shared/wsVPPAdminVisitorOffenderLookupDataInfo";

import { ConfirmationService } from "primeng/api";
import { AccordionModule } from "primeng/accordion";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./verifyvisitor.component.html",
	styleUrls: ["./verifyvisitor.component.css"],
	providers: [ConfirmationService],
})
export class VerifyVisitorComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_viewvisitor,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public Visitor_PersonID: number;
	public isAllowStatusChange: boolean = true;

	public VPPAdminVisitorEditData: wsVPPAdminVisitorEditDataInfo;

	public lstFacilityItems: wsVPPAdminVisitorEditDataFacilityInfo[] = [];
	public SelectedFacility: wsVPPAdminVisitorEditDataFacilityInfo;

	public lstTypeItems: wsVPPAdminVisitorEditDataTypeInfo[] = [];
	public SelectedType: wsVPPAdminVisitorEditDataTypeInfo;

	public lstStatusItems: wsVPPAdminVisitorEditDataStatusInfo[] = [];
	public SelectedStatus: wsVPPAdminVisitorEditDataStatusInfo;

	public lstGenderItems: wsVPPAdminVisitorEditDataGenderInfo[] = [];
	public SelectedGender: wsVPPAdminVisitorEditDataGenderInfo;

	public lstEthnicityItems: wsVPPAdminVisitorEditDataEthnicityInfo[] = [];
	public SelectedEthnicity: wsVPPAdminVisitorEditDataEthnicityInfo;

	public lstRaceItems: wsVPPAdminVisitorEditDataRaceInfo[] = [];
	public SelectedRace: wsVPPAdminVisitorEditDataRaceInfo;

	public rFirstName: string = "";
	public rMiddleName: string = "";
	public rLastName: string = "";
	public rDOB: Date = null;
	public rSSN: string = "";
	public rStreet1: string = "";
	public rStreet2: string = "";
	public rCity: string = "";
	public rState: string = "";
	public rZip: string = "";
	public rCellPhone: string = "";
	public rHomePhone: string = "";
	public rWorkPhone: string = "";
	public rEmail: string = "";
	public rEyeColor: string = "";
	public rHairColor: string = "";
	public rHeight: string = "";
	public rWeight: string = "";
	public rOffenderConfirmedInd: boolean = false;
	public PersonImageID: number = -1;
	public Person_Image: string = "";
	public isPersonImageChanged: boolean = false;

	public lstOffenderLookupData: wsVPPAdminVisitorOffenderLookupDataInfo[] = [];
	public isHitOnly: boolean = true;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.Visitor_PersonID = this.dialogConfig.data.Visitor_PersonID;
		this.isAllowStatusChange = this.dialogConfig.data.isAllowStatusChange;

		let parms: wsVPPAdminVisitorEditDataParm = {
			UserID: this.UserID,
			Visitor_PersonID: this.Visitor_PersonID,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorEditDataGet(parms).subscribe((data) => this.VPPAdminVisitorEditDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorEditDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorEditDataGet_Complete(data: any) {
		this.VPPAdminVisitorEditData = data;

		this.lstFacilityItems = this.VPPAdminVisitorEditData.FacilityItems;
		this.lstTypeItems = this.VPPAdminVisitorEditData.TypeItems;
		this.lstStatusItems = this.VPPAdminVisitorEditData.StatusItems;
		this.lstGenderItems = this.VPPAdminVisitorEditData.GenderItems;
		this.lstEthnicityItems = this.VPPAdminVisitorEditData.EthnicityItems;
		this.lstRaceItems = this.VPPAdminVisitorEditData.RaceItems;

		this.rFirstName = this.VPPAdminVisitorEditData.VisitorRecord.FirstName;
		this.rLastName = this.VPPAdminVisitorEditData.VisitorRecord.LastName;
		this.rMiddleName = this.VPPAdminVisitorEditData.VisitorRecord.MiddleName;

		if (this.VPPAdminVisitorEditData.VisitorRecord.DOB == null) {
			this.rDOB = null;
		} else {
			this.rDOB = new Date(this.VPPAdminVisitorEditData.VisitorRecord.DOB); // Must do new for this to work
		}

		this.rSSN = this.VPPAdminVisitorEditData.VisitorRecord.SSN;
		this.rStreet1 = this.VPPAdminVisitorEditData.VisitorRecord.Street1;
		this.rStreet2 = this.VPPAdminVisitorEditData.VisitorRecord.Street2;
		this.rCity = this.VPPAdminVisitorEditData.VisitorRecord.City;
		this.rState = this.VPPAdminVisitorEditData.VisitorRecord.State;
		this.rZip = this.VPPAdminVisitorEditData.VisitorRecord.Zip;
		this.rCellPhone = this.VPPAdminVisitorEditData.VisitorRecord.CellPhone;
		this.rHomePhone = this.VPPAdminVisitorEditData.VisitorRecord.HomePhone;
		this.rWorkPhone = this.VPPAdminVisitorEditData.VisitorRecord.WorkPhone;
		this.rEmail = this.VPPAdminVisitorEditData.VisitorRecord.Email;
		this.rEyeColor = this.VPPAdminVisitorEditData.VisitorRecord.EyeColor;
		this.rHairColor = this.VPPAdminVisitorEditData.VisitorRecord.HairColor;
		this.rHeight = this.VPPAdminVisitorEditData.VisitorRecord.Height;
		this.rWeight = this.VPPAdminVisitorEditData.VisitorRecord.Weight;
		this.PersonImageID = this.VPPAdminVisitorEditData.VisitorRecord.PersonImageID;
		this.Person_Image = this.VPPAdminVisitorEditData.VisitorRecord.Person_Image;
		this.rOffenderConfirmedInd = this.VPPAdminVisitorEditData.VisitorRecord.OffenderConfirmedInd;

		//
		//	Set Default Date For Add Visitor
		//
		if (this.Visitor_PersonID == -1) {
			this.rDOB = null;
		}

		//
		//	Select Default Facility
		//
		this.SelectedFacility = this.lstFacilityItems[0];

		//
		//	Select Default Type
		//
		this.SelectedType = this.lstTypeItems[0];

		this.lstTypeItems.forEach((item) => {
			if (this.Visitor_PersonID == -1) {
				if (item.VisitorTypeID == 3) {
					// Other
					this.SelectedType = item;
				}
			} else {
				if (item.VisitorTypeID == this.VPPAdminVisitorEditData.VisitorRecord.VisitorTypeID) {
					this.SelectedType = item;
				}
			}
		});

		//
		//	Select Default Status
		//
		this.SelectedStatus = this.lstStatusItems[0];

		this.lstStatusItems.forEach((item) => {
			if (this.Visitor_PersonID == -1) {
				if (item.VisitorStatusID == 2) {
					// Deny Entry
					this.SelectedStatus = item;
				}
			} else {
				if (item.VisitorStatusID == this.VPPAdminVisitorEditData.VisitorRecord.VisitorStatusID) {
					this.SelectedStatus = item;
				}
			}
		});

		//
		//	Select Default Gender
		//
		this.SelectedGender = this.lstGenderItems[0];

		this.lstGenderItems.forEach((item) => {
			if (item.GenderCD.toLowerCase() == this.VPPAdminVisitorEditData.VisitorRecord.GenderCD.toLowerCase()) {
				this.SelectedGender = item;
			}
		});

		//
		//	Select Default Ethnicity
		//
		this.lstEthnicityItems.unshift({
			EthnicityID: -1,
			EthnicityDesc: "- Not Specified -",
		});

		this.SelectedEthnicity = this.lstEthnicityItems[0];

		this.lstEthnicityItems.forEach((item) => {
			if (item.EthnicityID == this.VPPAdminVisitorEditData.VisitorRecord.EthnicityID) {
				this.SelectedEthnicity = item;
			}
		});

		//
		//	Select Default Race
		//
		this.lstRaceItems.unshift({
			RaceID: -1,
			RaceDesc: "- Not Specified -",
		});

		this.SelectedRace = this.lstRaceItems[0];

		this.lstRaceItems.forEach((item) => {
			if (item.RaceID == this.VPPAdminVisitorEditData.VisitorRecord.RaceID) {
				this.SelectedRace = item;
			}
		});

		//
		//	Get Offender Lookup Data
		//
		let parms: wsVPPAdminVisitorOffenderLookupDataParm = {
			PersonID: this.Visitor_PersonID,
			isHitOnly: this.isHitOnly,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorVerifyOffenderLookup(parms).subscribe((data) => this.VPPAdminVisitorVerifyOffenderLookup_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorVerifyOffenderLookup_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorVerifyOffenderLookup_Complete(data: any) {
		this.lstOffenderLookupData = data;
		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGroupChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGroupChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDOBChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDOBChange(val) {
		this.rDOB = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTypeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTypeChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGenderChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGenderChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEthnicityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEthnicityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRaceChange
	//
	//-----------------------------------------------------------------------------------------------------
	onRaceChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	chkHitOnly
	//
	//-----------------------------------------------------------------------------------------------------
	chkHitOnly(value) {
		//
		//	Get Offender Lookup Data
		//
		let parms: wsVPPAdminVisitorOffenderLookupDataParm = {
			PersonID: this.Visitor_PersonID,
			isHitOnly: this.isHitOnly,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorVerifyOffenderLookup(parms).subscribe((data) => this.VPPAdminVisitorVerifyOffenderLookup_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		//
		//	Edit Selected
		//
		let parms: wsVPPAdminVisitorVerifyModifyParm = {
			PersonID: this.Visitor_PersonID,
			VisitorStatusID: this.SelectedStatus.VisitorStatusID,
			OffenderConfirmedInd: this.rOffenderConfirmedInd,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVerifyVisitorEdit(parms).subscribe((data) => this.VPPAdminVerifyVisitorEdit_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVerifyVisitorEdit_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVerifyVisitorEdit_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
